<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="基地名称" name="baseName">
                <a-input v-model:value="searchForm.baseName" placeholder="请输入基地名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #baseLogo="{record}">
                <div  style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                    <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.baseLogo" :showList="true" disabled />
                </div>
            </template>
        </a-table>
    </a-card>
</template>

<script>
import {tableListMixin} from "@/mixins";
import {baseApi} from "@/api/innovationService";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "基地logo", dataIndex: "baseLogo", key: "baseLogo", slots: {customRender: "baseLogo"}},
    {title: "基地名称", dataIndex: "baseName", key: "baseName"},
    {title: "基地联系人", dataIndex: "baseContactsName", key: "baseContactsName"},
    {title: "基地地址", dataIndex: "baseAddress", key: "baseAddress"},
    {title: "基地面积", dataIndex: "baseArea", key: "baseArea"},
    {title: "基地人数", dataIndex: "basePeopleNum", key: "basePeopleNum"},
    {title: "基地描述", dataIndex: "baseDescription", key: "baseDescription",ellipsis:true,width:"100px"},
    {title: "入孵时间", dataIndex: "historyTime", key: "historyTime",customRender: defaultDateCustomRender},
    {title: "毕业时间", dataIndex: "graduationTime", key: "graduationTime",customRender: defaultDateCustomRender},
];
export default {
    name: "index",
    mixins: [tableListMixin],
    components: {
    },
    data() {
        return {
            columns,
            queryParam: {},
            listUrl: baseApi.historyList,
            listKeyField: "id",
        }
    },
    methods: {

    }
}
</script>

<style scoped>

</style>
